import ContactPage from './ContactPage.vue'

export default {
    'contact-page': ContactPage
}
